var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 94 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "upload-color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.996 16.9941C62.3445 16.9941 64.2384 18.8881 64.2384 21.2366V42.7517V51.7669V62.6002C64.2384 64.9487 62.3445 66.8427 59.996 66.8427H15.299H7.64746C5.29897 66.8427 3.40503 64.9487 3.40503 62.6002V21.2366C3.40503 18.8881 5.29897 16.9941 7.64746 16.9941H37.1929H59.996Z",
    strokeWidth: 2.74902,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8142 10.252C69.1627 10.252 71.0567 12.1459 71.0567 14.4944V36.0096V44.949V55.7823C71.0567 58.1308 69.1627 60.0247 66.8142 60.0247H22.1172H14.4657C12.1172 60.0247 10.2233 58.1308 10.2233 55.7823V14.4944C10.2233 12.1459 12.1172 10.252 14.4657 10.252H44.0112H66.8142Z",
    strokeWidth: 2.74902,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1627 2.90332C76.5112 2.90332 78.4052 4.79726 78.4052 7.14575V28.6609V37.6003V48.4337C78.4052 50.7821 76.5112 52.6761 74.1627 52.6761H29.4657H21.8142C19.4657 52.6761 17.5718 50.7821 17.5718 48.4337V7.14575C17.5718 4.79726 19.4657 2.90332 21.8142 2.90332H51.3597H74.1627Z",
    strokeWidth: 2.74902,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5715 17.1457V38.1305C42.5715 38.4336 42.8746 38.5851 43.1018 38.4336L58.1018 27.979C58.3291 27.8275 58.3291 27.5245 58.1018 27.373L43.1018 16.8426C42.8746 16.6911 42.5715 16.8426 42.5715 17.1457Z",
    strokeWidth: 2.74902,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "highlight"
  }, /*#__PURE__*/React.createElement("g", {
    className: "highlight-color"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 59,
    r: 14.1471,
    stroke: "#FAFAFA",
    strokeWidth: 2.29412
  })), /*#__PURE__*/React.createElement("g", {
    className: "hightlight-second-color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.6706 59.6465C81.5577 59.6465 81.4825 59.6089 81.4072 59.5336L77.2307 55.5453L73.0542 59.5336C72.9037 59.6841 72.6403 59.6841 72.4898 59.5336C72.3393 59.3831 72.3393 59.1197 72.4898 58.9692L77.1931 54.4541L81.8963 58.9692C82.0469 59.1197 82.0469 59.3455 81.8963 59.5336C81.8587 59.6089 81.7458 59.6465 81.6706 59.6465Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "hightlight-second-color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2305 64.3534C77.0048 64.3534 76.8542 64.2123 76.8542 64.0711V54.9249C76.8542 54.7555 77.0424 54.6426 77.2305 54.6426C77.4186 54.6426 77.6068 54.7837 77.6068 54.9249V64.0711C77.6068 64.2123 77.4563 64.3534 77.2305 64.3534Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadContent);
export default __webpack_public_path__ + "static/media/upload-content.c1ce79db28d148b92480c3a6a7218a1b.svg";
export { ForwardRef as ReactComponent };